/**
 * Operator-facing labels — collection credit review request UI (Slice D).
 */

import { COLLECTION_CREDIT_REVIEW_REQUEST_ENFORCEMENT_BOUNDARY_COPY } from '@shared/collection/collection-credit-review-request-types';

export const COLLECTION_CREDIT_REVIEW_OPERATOR_LABELS = {
  panelTitle: '신용 검토 요청 큐',
  boundaryCopy: COLLECTION_CREDIT_REVIEW_REQUEST_ENFORCEMENT_BOUNDARY_COPY,
  loadFailed: '신용 검토 요청을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  permissionUnavailable: '신용 검토 요청을 조회할 권한이 없습니다.',
  emptyQueue: '현재 처리 대기 중인 신용 검토 요청이 없습니다.',
  loading: '신용 검토 요청을 불러오는 중…',
  customerLabel: '고객',
  statusLabel: '상태',
  summaryLabel: '요약',
  sourceStaleBadge: '근거 변경됨',
  includeDeferredFilter: '보류 항목 포함',
  includeDeferredHint: '보류 중인 요청도 목록에 표시합니다.',
  refreshAfterMutation: '목록 새로고침',
  claimAction: '내가 처리',
  claimSubmitting: '처리 시작 중…',
  deferAction: '보류',
  deferSubmitting: '보류 중…',
  resolveAction: '완료 처리',
  resolveSubmitting: '완료 처리 중…',
  cancelAction: '취소',
  cancelSubmitting: '취소 중…',
  resolveModalTitle: '신용 검토 요청 완료',
  resolveModalBody:
    '완료 처리해도 신용 보류가 자동 적용되지 않습니다. AR·주문·신용 한도는 변경되지 않습니다.',
  resolutionCodeLabel: '완료 코드',
  resolutionCodePlaceholder: '코드 선택',
  resolutionNoteLabel: '메모 (선택)',
  resolutionNotePlaceholder: '추가 메모',
  resolveConfirm: '완료 처리',
  resolveCancel: '닫기',
  deferModalTitle: '신용 검토 요청 보류',
  deferUntilLabel: '보류 만료 시각',
  deferUntilPlaceholder: '만료 시각 선택',
  deferConfirm: '보류 적용',
  deferCancel: '닫기',
  mutationFailed: '요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  staleVersionMessage: '요청이 변경되었습니다. 목록을 새로고침한 뒤 다시 시도해 주세요.',
  forbiddenHoldLanguage: '신용 보류 적용',
} as const;

export const COLLECTION_CREDIT_REVIEW_RESOLUTION_LABELS: Record<string, string> = {
  no_action_required: '조치 불필요',
  continue_monitoring: '모니터링 지속',
  request_more_information: '추가 정보 요청',
  refer_for_hold_decision: '보류 결정 검토로 전달',
};
